<template>
  <el-form
    label-width="180px"
    ref="addCustomForm"
    :model="addCustomForm"
    :rules="addCustomFormRules"
  >
    <crm-panel class="mb20" style="padding-left: 150px">
      <el-row>
        <el-col :span="10">
          <el-form-item
            label="客户类型："
            prop="commonCustomer.categoryUid"
            :rules="addCustomFormRules.commonCustomer.categoryUid"
          >
            <el-select
              clearable
              v-model="addCustomForm.commonCustomer.categoryUid"
              placeholder="请选择"
              @change="handleCustomerTypeChange"
            >
              <el-option
                v-for="item in customType"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :offset="2">
          <crm-uploadAdd :handleUploadSucess="handleUploadSucess" />
        </el-col>
      </el-row>
      <div v-if="customerModule === 1">
        <el-form-item
          label="客户名称："
          class="is-required"
          prop="commonCustomer.name"
          :rules="[]"
        >
          <el-row>
            <el-col :span="11">
              <el-form-item
                prop="commonCustomer.name"
                :rules="addCustomFormRules.commonCustomer.name"
              >
                <el-input v-model.trim="addCustomForm.commonCustomer.name" placeholder="">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="统一社会信用代码："
          prop="creditCode"
          @blur="creditCodeValidate"
        >
          <el-col :span="11">
            <el-input v-model.trim="addCustomForm.creditCode"> </el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="注册资金："
          prop="commonCustomer.capital"
          :rules="addCustomFormRules.commonCustomer.capital"
        >
          <el-col :span="11">
            <el-input v-model="addCustomForm.commonCustomer.capital"> </el-input>
          </el-col>
          <el-col :span="1" style="marginleft: 10px">
            <span>万元</span>
          </el-col>
        </el-form-item>
        <el-form-item label="规模：" prop="commonCustomer.scale">
          <el-col :span="11">
            <el-select clearable v-model="addCustomForm.commonCustomer.scale">
              <el-option
                v-for="item in scaleOption"
                :label="item.label"
                :value="item.label"
                :key="item.key"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </div>
      <div v-if="customerModule === 2">
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="客户名称："
              prop="commonCustomer.name"
              :rules="addCustomFormRules.commonCustomer.name"
            >
              <el-input v-model="addCustomForm.commonCustomer.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="统一社会信用代码："
              prop="creditCode"
            >
              <el-input @blur="creditCodeValidate" v-model.trim="addCustomForm.creditCode"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="跟进状态："
              prop="followUpState"
              :rules="addCustomFormRules.followUpState"
            >
              <el-select clearable v-model="addCustomForm.followUpState">
                <el-option
                  v-for="item in customerFollowUp ? customerFollowUp : ''"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="医院等级："
              prop="hospitalLevel"
              :rules="addCustomFormRules.hospitalLevel"
            >
              <el-select clearable v-model="addCustomForm.hospitalLevel">
                <el-option
                  v-for="item in hospitalLevel ? hospitalLevel : ''"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="病床数：" prop="sickbedNumber">
              <el-input v-model="addCustomForm.sickbedNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="覆盖人口(万)：" prop="coverPopulation">
              <el-input v-model="addCustomForm.coverPopulation"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="当地医院排名：" prop="hospitalRhanking">
              <el-input v-model="addCustomForm.hospitalRhanking"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="年收入(万)：" prop="annualIncome">
              <el-input v-model="addCustomForm.annualIncome"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="职工人数：" prop="employeeNumber">
              <el-input v-model="addCustomForm.employeeNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="年门诊人次(万)：" prop="outpatientVisits">
              <el-input v-model="addCustomForm.outpatientVisits"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="合作科室：" prop="addDetail">
              <el-select clearable v-model="addCustomForm.addDetail" multiple>
                <el-option
                  :key="item.uid"
                  v-for="item in coprationDepartment ? coprationDepartment : ''"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="年住院人次(万)：" prop="hospitalizationVisits">
              <el-input v-model="addCustomForm.hospitalizationVisits"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="负债率：" prop="liabilities">
              <el-input v-model="addCustomForm.liabilities"></el-input>
              <span style="position: absolute; top: 0px; left: 200px">%</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="客户等级：">
              <el-select
                clearable
                v-model="addCustomForm.commonCustomer.customerLevel"
                placeholder="客户等级"
              >
                <el-option
                  v-for="item in customLevelList"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="医疗设备：" prop="medicalEquipment">
            <el-radio-group
              v-model="addCustomForm.medicalEquipment"
              @change="changeMedicalEquipment"
            >
              <el-radio :label="1">有</el-radio>
              <el-radio :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <div v-if="addCustomForm.medicalEquipment === 1">
          <div>
            <el-form-item label="设备名称：" prop="deviceName">
              <el-col :span="11">
                <el-input type="textarea" :rows="4" v-model="addCustomForm.deviceName">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
          <el-row>
            <el-col :span="10">
              <el-form-item label="设备总金额(万元)：" prop="deviceAmount">
                <el-input v-model="addCustomForm.deviceAmount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-form-item label="耗材：" prop="consumables">
            <el-radio-group
              v-model="addCustomForm.consumables"
              @change="changeConsumables"
            >
              <el-radio :label="1">有</el-radio>
              <el-radio :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row v-if="addCustomForm.consumables === 1">
          <el-col :span="10">
            <el-form-item label="预估耗材流水(万元/年)：" prop="consumablesRunningWater">
              <el-input v-model="addCustomForm.consumablesRunningWater"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <el-form-item label="备注：" prop="customerRemarks">
            <el-col :span="11">
              <el-input type="textarea" :rows="4" v-model="addCustomForm.customerRemarks">
              </el-input>
            </el-col>
          </el-form-item>
        </div>
      </div>
      <div v-if="customerModule">
        <div class="area-wrap">
          <el-form-item v-if="customerModule !== 2" label="客户等级：" prop="commonCustomer.customerLevel">
            <el-col :span="11">
              <el-select
                clearable
                v-model="addCustomForm.commonCustomer.customerLevel"
                placeholder="客户等级"
              >
                <el-option
                  v-for="item in customLevelList"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            label="地区："
            prop="commonCustomer.province"
            :rules="addCustomFormRules.commonCustomer.province"
          >
            <!-- <el-cascader
              clearable
              placeholder="地区"
              v-model="level3Linkage.selected"
              :props='level3Linkage.props'
              :options="level3Linkage.options"
              @change="searchDistrict(level3Linkage.selected)">
            </el-cascader> -->
            <el-col :span="5">
              <el-form-item
                prop="commonCustomer.province"
                :rules="addCustomFormRules.commonCustomer.province"
              >
                <el-select
                  v-model="addCustomForm.commonCustomer.province"
                  @change="selsectProvince"
                  placeholder="请选择省份"
                >
                  <el-option
                    v-for="item in level3Linkage.provinceList"
                    :label="item.name"
                    :value="item.name"
                    :key="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-form-item
                prop="commonCustomer.city"
                :rules="addCustomFormRules.commonCustomer.city"
              >
                <el-select
                  v-model="addCustomForm.commonCustomer.city"
                  @change="selectCity"
                  placeholder="请选择城市"
                >
                  <el-option
                    v-for="item in level3Linkage.cityList.city"
                    :label="item.name"
                    :value="item.name"
                    :key="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-form-item
                prop="commonCustomer.district"
                :rules="addCustomFormRules.commonCustomer.district"
              >
                <el-select
                  v-model="addCustomForm.commonCustomer.district"
                  placeholder="请选择区县"
                >
                  <el-option
                    v-for="(item, index) in level3Linkage.districtList.area"
                    :label="item"
                    :value="item"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
        </div>
        <div class="require">
          <el-form-item label="详细地址：" prop="streetAddress">
            <el-col :span="11">
              <el-input type="textarea" :rows="4" v-model="addCustomForm.streetAddress">
              </el-input>
            </el-col>
          </el-form-item>
        </div>
        <el-form-item
          label="业务员："
          prop="commonCustomer.salesmanCode"
          :rules="addCustomFormRules.commonCustomer.salesmanCode"
        >
          <el-col :span="5">
            <el-select
              clearable
              filterable
              v-model="addCustomForm.commonCustomer.salesmanCode"
              value-key="code"
            >
              <el-option
                v-for="item in clerkList"
                :label="`${item.userName} - ${item.loginId}`"
                :value="item.code"
                :key="item.code"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </div>
    </crm-panel>
    <div v-if="customerModule">
      <crm-panel
        :title="`客户联系人${index + 1}`"
        v-for="(item, index) in addCustomForm.addCustomerContact"
        :key="index"
        class="mb20"
      >
        <div class="page-buttons">
          <crm-button
            v-if="addCustomForm.addCustomerContact.length > 1"
            :text="'删除'"
            :buttonType="'danger'"
            :size="'mini'"
            :icon="'el-icon-delete'"
            @click="deleteCustomerContact(index)"
          >
          </crm-button>
        </div>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="联系人："
              :prop="'addCustomerContact.' + index + '.name'"
              :rules="[
                {
                  required: true,
                  message: '请填写联系人名称',
                  trigger: 'blur',
                },
                { max: 20, message: '最多20字', trigger: 'blur' },
              ]"
            >
              <el-input v-model="item.name" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="联系方式："
              :prop="'addCustomerContact.' + index + '.mobile'"
              :rules="[
                {
                  pattern: /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
                  message: '请输入固话或者手机号',
                },
                { required: true, message: '请填写联系方式', trigger: 'blur' },
                { max: 20, message: '最多20字', trigger: 'blur' },
              ]"
            >
              <el-input v-model.trim="item.mobile" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="职务："
              :prop="'addCustomerContact.' + index + '.duty'"
              :rules="[
                {
                  required: true,
                  message: '请填写联系人职务',
                  trigger: 'blur',
                },
                { max: 20, message: '最多20字', trigger: 'blur' },
              ]"
            >
              <el-input v-model="item.duty" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="联系人类型："
              :prop="'addCustomerContact.' + index + '.contactType'"
              :rules="{
                required: true,
                message: '请选择联系人类型',
                trigger: 'change',
              }"
            >
              <el-select clearable v-model="item.contactType" value-key="uid">
                <el-option
                  v-for="item in contactsType ? contactsType.results : ''"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="部门："
              :prop="'addCustomerContact.' + index + '.contactDepa'"
              :rules="[
                { max: 20, message: '最多20字', trigger: 'blur' },
                {
                  required: true,
                  message: '请填写部门',
                  trigger: 'change',
                },
              ]"
            >
              <el-input v-model="item.contactDepa" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="邮箱："
              :prop="'addCustomerContact.' + index + '.contactEmail'"
              :rules="{ max: 30, message: '最多30字', trigger: 'blur' }"
            >
              <el-input v-model="item.contactEmail" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="座机："
              :prop="'addCustomerContact.' + index + '.landline'"
              :rules="[
                { max: 20, message: '最多20字', trigger: 'blur' },
                {
                  pattern: /^(\d+-\d+|\d*)$/,
                  message: '座机必须为数字',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="item.landline" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="微信/QQ："
              :prop="'addCustomerContact.' + index + '.contactQQ'"
              :rules="[
                { max: 20, message: '最多20字', trigger: 'blur' },
                {
                  pattern: /^[a-zA-Z0-9_-]+$/,
                  message: '不能输入特殊符号',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="item.contactQQ" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </crm-panel>
      <div class="text-middle mt30">
        <crm-button
          :text="'添加联系人'"
          :size="'default'"
          :icon="'el-icon-plus'"
          @click="addCustomerContact()"
        >
        </crm-button>
      </div>
    </div>
  </el-form>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import * as utils from "@/scripts/utils";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";
import CrmUploadAdd from "@/components/base/crmUploadAdd";

export default {
  props: {
    detail: Object,
  },
  components: {
    CrmPanel,
    CrmButton,
    CrmUploadAdd,
  },
  data() {
    const fiveNumberRule = (rule, value, callback) => {
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 99999.99) {
        callback(new Error("最多五位数"));
      } else {
        callback();
      }
    };
    const nineNumberRule = (rule, value, callback) => {
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 999999999.99) {
        callback(new Error("最多九位数"));
      } else {
        callback();
      }
    };
    const fourNumberRule = (rule, value, callback) => {
      if (rule.fullField === "hospitalizationVisits" && !value) {
        callback();
        return;
      }
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 9999.99) {
        callback(new Error("最多四位数"));
      } else {
        callback();
      }
    };
    const liabilitiesRule = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      if (!/^100$|^(\d|[1-9]\d)(\.\d{0,2})*$/.test(value) && value !== "100.00") {
        callback(new Error("请输入最多两位小数0-100的数字"));
      } else {
        callback();
      }
    };
    this.scaleOption = [
      {
        label: "50人以下",
        key: "50人以下",
      },
      {
        label: "50-200人",
        key: "50-200人",
      },
      {
        label: "200-500人",
        key: "200-500人",
      },
      {
        label: "500-1000人",
        key: "500-1000人",
      },
      {
        label: "1000-5000人",
        key: "1000-5000人",
      },
      {
        label: "5000人以上",
        key: "5000人以上",
      },
    ];
    return {
      // 客户模板
      customerModule: null,
      // 待提交的表单数据
      addCustomForm: {
        // 不同类型客户的相同数据模型
        commonCustomer: {
          customerLevel: "",
          categoryUid: "",
          categoryName: "",
          name: "",
          salesmanCode: "",
          salesmanName: "",
          province: "",
          city: "",
          district: "",
          capital: "",
          scale: "",
        },
        businessLicenseNum: "",
        organizationCode: "",
        creditCode: "",
        streetAddress: "",
        // 联系人数据模型
        addCustomerContact: [
          {
            name: "",
            mobile: "",
            duty: "",
            contactType: "",
            contactEmail: "",
            contactDepa: "",
          },
        ],
        followUpState: "",
        hospitalLevel: "",
        sickbedNumber: null,
        coverPopulation: null,
        hospitalRhanking: null,
        annualIncome: null,
        employeeNumber: null,
        outpatientVisits: null,
        addDetail: [],
        addCustomerDetail: [],
        hospitalizationVisits: null,
        liabilities: "",
        medicalEquipment: null,
        deviceName: "",
        deviceAmount: "",
        consumables: null,
        consumablesRunningWater: "",
        customerRemarks: "",
      },
      // 表单校验规则
      addCustomFormRules: {
        commonCustomer: {
          categoryUid: [{ required: true, message: "请选择客户类型", trigger: "change" }],
          name: [
            { pattern: /^\S+$/, message: "不能输入空格", trigger: "change" },
            { required: true, message: "请填写客户公司名称", trigger: "blur" },
            {
              min: 0,
              max: 100,
              message: "最多100个字",
              trigger: "blur",
            },
          ],
          capital: [
            {
              pattern: /^\d+(\.\d{0,2})*$/,
              message: "必须为数字",
              trigger: "blur",
            },
            {
              min: 0,
              max: 8,
              message: "最多8个数字",
              trigger: "blur",
            },
          ],
          province: [{ required: true, message: "请选择省/直辖市", trigger: "change" }],
          city: [{ required: true, message: "请选择城市", trigger: "change" }],
          district: [{ required: true, message: "请选择区/县", trigger: "change" }],
          salesmanCode: [{ required: true, message: "请选择业务员", trigger: "change" }],
        },
        businessLicenseNum: [
          { pattern: /^\d*$/, message: "必须为数字", trigger: "blur" },
          {
            min: 15,
            max: 15,
            message: "请输入15位营业执照注册号",
            trigger: "blur",
          },
        ],
        organizationCode: [
          {
            min: 10,
            max: 10,
            message: "请输入10位组织机构代码",
            trigger: "blur",
          },
        ],
        creditCode: [
          {
            min: 18,
            max: 18,
            message: "请输入18位统一社会信用代码",
            trigger: "blur",
          },
        ],
        streetAddress: [{ required: true, message: "请填写详细地址", trigger: "blur" }],
        followUpState: [{ required: true, message: "请选择跟进状态", trigger: "change" }],
        hospitalLevel: [{ required: true, message: "请选择医院等级", trigger: "change" }],
        sickbedNumber: [
          { required: true, message: "请填写病床数量", trigger: "blur" },
          { pattern: /^\d*$/, message: "必须为数字", trigger: "blur" },
          {
            min: 0,
            max: 6,
            message: "最多6位数",
            trigger: "blur",
          },
        ],
        coverPopulation: [
          { required: true, message: "请填写覆盖人口", trigger: "blur" },
          { validator: fiveNumberRule, trigger: "blur" },
        ],
        hospitalRhanking: [
          { required: false, message: "请填写当地医院排名", trigger: "blur" },
          { pattern: /^\d*$/, message: "必须为数字", trigger: "blur" },
          {
            min: 0,
            max: 3,
            message: "最多3位数",
            trigger: "blur",
          },
        ],
        annualIncome: [
          { required: true, message: "请填写年收入", trigger: "blur" },
          { validator: nineNumberRule, trigger: "blur" },
        ],
        employeeNumber: [
          { required: true, message: "请填写职工人数", trigger: "blur" },
          { pattern: /^\d*$/, message: "必须为数字", trigger: "blur" },
          {
            min: 0,
            max: 5,
            message: "最多5位数",
            trigger: "blur",
          },
        ],
        outpatientVisits: [
          { required: true, message: "请填写年门诊人次", trigger: "blur" },
          { validator: fourNumberRule, trigger: "blur" },
        ],
        hospitalizationVisits: [
          { required: false, message: "请填写年住院人次", trigger: "blur" },
          { validator: fourNumberRule, trigger: "blur" },
        ],
        liabilities: [
          { required: false, message: "请填写负债率", trigger: "blur" },
          { validator: liabilitiesRule, trigger: "blur" },
        ],
        medicalEquipment: [
          { required: false, message: "请选择医疗设备有无", trigger: "change" },
        ],
        deviceName: [
          { required: true, message: "请填写设备名称", trigger: "blur" },
          { max: 200, message: "最多200字", trigger: "blur" },
        ],
        deviceAmount: [
          { required: true, message: "请填写设备总金额", trigger: "blur" },
          { validator: fiveNumberRule, trigger: "blur" },
        ],
        consumables: [{ required: false, message: "请选择耗材有无", trigger: "change" }],
        consumablesRunningWater: [
          { required: true, message: "请填写设备总金额", trigger: "blur" },
          { validator: fiveNumberRule, trigger: "blur" },
        ],
        customerRemarks: [{ max: 100, message: "最多100字", trigger: "blur" }],
        addDetail: [{ required: true, message: "请选择合作科室", trigger: "change" }],
      },
      // 三级联动
      level3Linkage: {
        provinceList: utils.country,
        cityList: [],
        districtList: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "authority/userInfo",
      customType: "customer/customType",
      contactsType: "common/contactsType",
      clerkList: "common/clerkList",
      coprationDepartment: "compact/coprationDepartment",
      hospitalLevel: "customer/hospitalLevel",
      customerFollowUp: "customer/customerFollowUp",
      customLevelList: "common/customLevelList",
    }),
  },
  watch: {
    detail(val) {
      this.addCustomForm.commonCustomer.name = val.companyName;
      this.addCustomForm.commonCustomer.province = val.province;
      this.addCustomForm.commonCustomer.city = val.city;
      this.addCustomForm.commonCustomer.district = val.district;
      this.addCustomForm.streetAddress = val.streetAddress;
      this.addCustomForm.customerLevel = val.customerLevel;
      this.addCustomForm.addCustomerContact = [
        {
          name: val.name,
          mobile: val.mobile,
          duty: val.duty,
          contactType: "",
          contactDepa: val.department,
          contactEmail: "",
        },
      ];
    },
  },
  created() {
    // 客户类型列表
    this.getCustomType({
      pageNumber: 1,
      pageSize: 50,
      code: "category_customer",
    });
    // 联系人类型列表
    this.getContactsType({
      code: "category_contact",
    });
    // 医院等级列表
    this.getHospitalLevelType({
      code: "category_hospital_level",
    });
    // 跟进状态列表
    this.getCustomerFollowUp({
      code: "category_customer_followUp",
    });
    // 业务员列表
    this.getClerkList().then(() => {
      if (!this.addCustomForm.commonCustomer.salesmanCode) {
        this.addCustomForm.commonCustomer.salesmanCode = this.userInfo.userUid;
      }
    });
    // 获取客户等级
    this.getCustomerLevel();

    // 获取合作科室
    if (this.coprationDepartment.length === 0) {
      this.getCoprationDepartmentList({
        pageNumber: 1,
        pageSize: 100,
        code: "category_department",
      });
    }
  },
  methods: {
    ...mapActions({
      getCustomType: "customer/getCustomType",
      getContactsType: "common/getContactsType",
      getClerkList: "common/getClerkList",
      getCoprationDepartmentList: "compact/getCoprationDepartmentList",
      getHospitalLevelType: "customer/getHospitalLevelType",
      getCustomerFollowUp: "customer/getCustomerFollowUp",
      getCustomerLevel: "common/getCustomerLevel",
    }),
    handleReturnData() {
      return this.$refs.addCustomForm.validate().then((valid) => {
        if (valid) {
          this.addCustomForm.addCustomerContact.forEach((item) => {
            item.salesmanCode = this.addCustomForm.commonCustomer.salesmanCode;
            item.customerUid = "";
          });
          // 根据categoryUid字段手动补充categoryName字段
          // 根据salesmanCode字段手动补充salesmanName字段
          this.addCustomForm.commonCustomer.categoryName = this.getCategoryName(
            this.addCustomForm.commonCustomer.categoryUid
          );
          this.addCustomForm.commonCustomer.salesmanName = this.getSalesmanName(
            this.addCustomForm.commonCustomer.salesmanCode
          );

          const name = this.addCustomForm.commonCustomer.name;
          this.addCustomForm.commonCustomer.name = name.replace(/\s*/g, "");
          this.addCustomForm.addCustomerDetail = [];
          this.addCustomForm.addDetail.forEach((item) => {
            this.addCustomForm.addCustomerDetail.push({ dictId: item });
          });
          const { addDetail, ...otherParams } = this.addCustomForm;
          return otherParams;
        }
        return null;
      });
    },
    creditCodeValidate() {
      // 2021年05月14日17:29:09 需求变更 除了政府和医生两个客户类型，其他的类型的客户，均把统一社会信用代码改成必填项
      if (
        ![
          "b8b2e093efd548a18259807bcb7fda2f",
          "3daef4ba2a424d9ba076f2189ec2acb8",
          "26229ed2c2814e05a83ae8c71edcddb0",
          "ed67aad9552b4f1b8520785b9cb4bfd1",
        ].includes(this.addCustomForm.commonCustomer.categoryUid)
      ) {
        this.$refs.addCustomForm.clearValidate("creditCode");

        this.addCustomFormRules.creditCode.push({
          required: true,
          message: "请输入18位统一社会信用代码",
          trigger: "blur",
        });
      } else {
        this.$refs.addCustomForm.clearValidate("creditCode");
        this.addCustomFormRules.creditCode = [
          {
            min: 18,
            max: 18,
            message: "请输入18位统一社会信用代码",
            trigger: "blur",
          },
        ];
      }
    },
    handleCustomerTypeChange(val) {
      console.log(val);
      if (val === "ed67aad9552b4f1b8520785b9cb4bfd1") {
        this.customerModule = 2;
      } else {
        // this.rules = this.rules1;
        this.customerModule = 1;
      }
      // 2021年05月14日17:29:09 需求变更 除了政府和医生两个客户类型，其他的类型的客户，均把统一社会信用代码改成必填项
      this.creditCodeValidate();
    },
    // 获取客户类型名称
    getCategoryName(categoryUid) {
      const category = this.customType.find((item) => item.uid === categoryUid);
      return category ? category.name : "";
    },
    // 获取业务员名称
    getSalesmanName(salesmanCode) {
      const salesman = this.clerkList.find((item) => item.code === salesmanCode);
      return salesman ? salesman.userName : "";
    },
    /**
     * 联动省/直辖市下拉菜单
     */
    selsectProvince() {
      this.addCustomForm.commonCustomer.city = "";
      this.addCustomForm.commonCustomer.district = "";
      const cityList = this.level3Linkage.provinceList.find(
        (item) => item.name === this.addCustomForm.commonCustomer.province
      );
      this.level3Linkage.cityList = cityList || [];
      this.level3Linkage.districtList = [];
      return true;
    },
    /**
     * 联动城市下拉菜单
     */
    selectCity() {
      this.addCustomForm.commonCustomer.district = "";
      const district = this.level3Linkage.cityList.city.find(
        (item) => item.name === this.addCustomForm.commonCustomer.city
      );
      this.level3Linkage.districtList = district || [];
      return true;
    },
    /**
     * 新增客户联系人
     */
    addCustomerContact() {
      this.addCustomForm.addCustomerContact.push({
        name: "",
        mobile: "",
        duty: "",
        contactType: "",
        contactEmail: "",
        contactDepa: "",
      });
    },
    deleteCustomerContact(index) {
      this.addCustomForm.addCustomerContact.splice(index, 1);
    },
    handleUploadSucess(data) {
      this.addCustomForm.commonCustomer.name = data.name;
      this.addCustomForm.commonCustomer.province = data.province;
      this.addCustomForm.commonCustomer.city = data.city;
      this.addCustomForm.commonCustomer.district = data.district;
      this.addCustomForm.streetAddress = data.streetAddress;

      this.addCustomForm.addCustomerContact = [
        {
          name: data.NAME[0],
          mobile: data.MOBILE[0],
          duty: data.TITLE[0],
          contactType: "",
          contactDepa: data.department,
          contactEmail: data.EMAIL[0],
        },
      ];
    },
    changeMedicalEquipment() {
      if (
        !this.addCustomForm.medicalEquipment ||
        this.addCustomForm.medicalEquipment === 2
      ) {
        this.addCustomForm.deviceAmount = "";
        this.addCustomForm.deviceName = "";
      }
    },
    changeConsumables() {
      if (!this.addCustomForm.consumables || this.addCustomForm.consumables === 2) {
        this.addCustomForm.consumablesRunningWater = "";
      }
    },
  },
};
</script>

<style></style>
